import type { SignalDateSelection } from '@/features/(signal)/signals/model';
import { SignalDutationSelecter } from '@/features/(signal)/signals/ui/signal-header';
import type { StructuredFilterQueryInterface } from '@/features/StructuredFilter/hooks/useStructuredFilterQuery';
import StructuredFilter from '@/features/StructuredFilter/StructuredFilter';

export const FilterArea = (
  props: StructuredFilterQueryInterface & {
    datePreset: SignalDateSelection;
    setDatePreset: (selection: SignalDateSelection) => void;
  },
) => {
  return (
    <div className="flex space-between items-center gap-4 px-8 pb-4">
      <div className="flex-1">
        <StructuredFilter
          values={props.filterQueryFormats}
          onChange={props.onFilterSetChange}
          clearFilter={props.clearFilter}
        />
      </div>
      <div>
        <SignalDutationSelecter
          value={props.datePreset}
          onChange={props.setDatePreset}
        />
      </div>
    </div>
  );
};
